import { AppState } from '../store';

export const selectAuthLoggedIn = (store: AppState): boolean => {
  return store.auth.loggedIn;
};
